import React from 'react';
import './Team.css';

const Team = () => {
  const directors = [
    {
      name: 'Wanasinhage Ruwan Sanjeewa',
      position: 'Director',
      contact: '+94713167976',
      description: 'Overseeing company operations, strategic planning, and business development.',
      education: 'Bachelor of Arts and Master\'s degree in Information Technology from University of Kelaniya',
      expertise: 'IT and database management'
    },
    {
      name: 'K.B.C. Padmini Karunaratne',
      position: 'Director',
      description: 'Extensive leadership experience and business insight.',
      expertise: 'Strategic direction and innovative IT solutions in library automation'
    }
  ];

  return (
    <section id="team" className="team section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Our Team</h2>
          <p className="section-subtitle">
            Experienced professionals dedicated to delivering exceptional library automation solutions
          </p>
        </div>
        
        <div className="team-content">
          <div className="team-grid">
            {directors.map((director, index) => (
              <div key={index} className="team-card card">
                <div className="team-card-header">
                  <div className="team-avatar">
                    <span className="avatar-text">{director.name.split(' ').map(n => n[0]).join('')}</span>
                  </div>
                  <div className="team-info">
                    <h4 className="team-name">{director.name}</h4>
                    <p className="team-position">{director.position}</p>
                    {director.contact && (
                      <p className="team-contact">{director.contact}</p>
                    )}
                  </div>
                </div>
                <div className="team-card-content">
                  <p className="team-background">{director.description}</p>
                  {director.education && (
                    <p className="team-education"><strong>Education:</strong> {director.education}</p>
                  )}
                  <p className="team-expertise"><strong>Expertise:</strong> {director.expertise}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Team;


